export default {
    it: {
        "base_select": "Lista opzioni",
        "base_error": "Errore!",

        "contact_times": "Vorrei essere contattato preferibilmente nella seguente fascia oraria",
        "contact_times_error": "Per favore seleziona un orario di contatto",

        "pgpf": "Stai operando come persona fisica o come persona giuridica?",
        "pgpf_error": "Per favore seleziona un valore",

        "legal": "Stai presentando una richiesta di informazioni di carattere giuridico-normativo?",
        "legal_error": "Per favore seleziona un valore",

        "persona": "Persona Fisica / Giuridica",
        "persona_error": "Per favore seleziona un valore",

        "elenco_registro": "Elenco/Registro",
        "elenco_registro_error": "Per favore seleziona un valore",

        "job": "Seleziona a quale tra queste categorie appartieni",
        "job_error": "Per favore seleziona un valore",

        "document_type_1": "Tipo documento 1",
        "document_type_1_error": "Per favore seleziona un valore",

        "document_type_2": "Tipo documento 2",
        "document_type_2_error": "Per favore seleziona un valore",


        "area_preferenza": "Area preferenza",
        "area_preferenza-field-not-ok": "Per favore seleziona un'area di preferenza",
    },
    en: {
        "base_select": "Option list",
        "base_error": "Error!",

        "contact_times": "Preferred contact time",
        "contact_times_error": "Please choose a contact time",

        "pgpf": "Are you operating as a natural person or as a legal person?",
        "pgpf_error": "Per favore seleziona un valore",

        "legal": "Are you submitting a request for legal-regulatory information?",
        "legal_error": "Per favore seleziona un valore",

        "persona": "Physical / Legal Person",
        "persona_error": "Per favore seleziona un valore",

        "elenco_registro": "List / Register",
        "elenco_registro_error": "Per favore seleziona un valore",

        "job": "Select which of these categories you belong to",
        "job_error": "Per favore seleziona un valore",

        "document_type_1": "Document type 1",
        "document_type_1_error": "Per favore seleziona un valore",

        "document_type_2": "Document type 2",
        "document_type_2_error": "Per favore seleziona un valore",
       
        "area_preferenza": "Preference Area",
        "area_preferenza-field-not-ok": "Please choose a Preference Area",
    }
}